var _rect, _rect2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPersonBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    fill: "#D1EFE6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "#6D708D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0013 18.1667C18.6606 18.1667 19.305 17.9712 19.8532 17.6049C20.4014 17.2386 20.8286 16.718 21.0809 16.1089C21.3332 15.4999 21.3992 14.8296 21.2706 14.183C21.142 13.5364 20.8245 12.9425 20.3583 12.4763C19.8921 12.0101 19.2982 11.6927 18.6516 11.5641C18.005 11.4354 17.3348 11.5014 16.7257 11.7537C16.1166 12.006 15.596 12.4333 15.2297 12.9814C14.8635 13.5296 14.668 14.1741 14.668 14.8333C14.668 15.7174 15.0192 16.5652 15.6443 17.1904C16.2694 17.8155 17.1172 18.1667 18.0013 18.1667ZM18.0013 13.1667C18.3309 13.1667 18.6532 13.2644 18.9273 13.4476C19.2013 13.6307 19.415 13.891 19.5411 14.1955C19.6672 14.5001 19.7003 14.8352 19.6359 15.1585C19.5716 15.4818 19.4129 15.7788 19.1798 16.0118C18.9467 16.2449 18.6498 16.4037 18.3265 16.468C18.0032 16.5323 17.668 16.4993 17.3635 16.3731C17.059 16.247 16.7987 16.0334 16.6155 15.7593C16.4324 15.4852 16.3346 15.163 16.3346 14.8333C16.3346 14.3913 16.5102 13.9674 16.8228 13.6548C17.1354 13.3423 17.5593 13.1667 18.0013 13.1667ZM18.0013 19.8333C16.4542 19.8333 14.9705 20.4479 13.8765 21.5419C12.7826 22.6358 12.168 24.1196 12.168 25.6667C12.168 25.8877 12.2558 26.0996 12.412 26.2559C12.5683 26.4122 12.7803 26.5 13.0013 26.5C13.2223 26.5 13.4343 26.4122 13.5906 26.2559C13.7468 26.0996 13.8346 25.8877 13.8346 25.6667C13.8346 24.5616 14.2736 23.5018 15.055 22.7204C15.8364 21.939 16.8962 21.5 18.0013 21.5C19.1064 21.5 20.1662 21.939 20.9476 22.7204C21.729 23.5018 22.168 24.5616 22.168 25.6667C22.168 25.8877 22.2558 26.0996 22.412 26.2559C22.5683 26.4122 22.7803 26.5 23.0013 26.5C23.2223 26.5 23.4343 26.4122 23.5906 26.2559C23.7468 26.0996 23.8346 25.8877 23.8346 25.6667C23.8346 24.1196 23.2201 22.6358 22.1261 21.5419C21.0321 20.4479 19.5484 19.8333 18.0013 19.8333Z",
    fill: "#36384A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonBadge);
export default __webpack_public_path__ + "static/media/PersonBadge.d92f9eece856deb411e25db30ff84d0d.svg";
export { ForwardRef as ReactComponent };